import merge from 'lodash/merge';
import { DateTime } from 'luxon';

import type { Report } from 'app-components/flux/generated-reports/generatedReportsTypes';
import type { TaxBracketRow, TaxRates } from 'app-components/flux/taxes/taxRates';

import type { FilingStatus, TaxInputProps } from './taxesTypes';

// TODO: add year parameter if we want to estimate for a different years
export const estimatedAnnualAmount = (taxYear: number, amount: number | undefined): number | undefined => {
  if (amount === undefined) {
    return undefined;
  }
  const now = DateTime.now();
  if (now.year !== taxYear) {
    return amount;
  }
  const dayOfYear = now.ordinal;
  const daysInYear = now.daysInYear;
  return (amount * daysInYear) / dayOfYear;
};

export const mapTaxReportToTaxInput = (taxReport: Report): TaxInputProps => {
  const valueColumn = taxReport.columns?.find(
    (column) => 'id' in column.headerValue && column.headerValue.id === 'Amount',
  );
  if (!valueColumn) {
    return {};
  }

  const taxInputProps = taxReport.rows.reduce((taxInput: TaxInputProps, row) => {
    if (row.entityType === 'TAX_LINE_ITEM') {
      const valueString = row.cellData.find((cell) => cell.columnId === valueColumn.id)?.value;
      const valueNumber = Number(valueString);
      const value = isNaN(valueNumber) ? undefined : valueNumber;
      if (value) {
        switch (row.entityId) {
          case 'USA_327':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { royalties: { value: (taxInput.scheduleE?.royalties?.value || 0) + value } },
            });
            break;
          case 'USA_502':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_329':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_335':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_823':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: {
                rentalPropertyMileage: { value: (taxInput.scheduleE?.rentalPropertyMileage?.value || 0) + value },
              },
            });
            break;
          case 'USA_326':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { rents: { value: (taxInput.scheduleE?.rents?.value || 0) + value } },
            });
            break;
          case 'USA_331':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_334':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_339':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_338':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_332':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_336':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_341':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: {
                unspecifiedRentalPropertyExpense: {
                  value: (taxInput.scheduleE?.unspecifiedRentalPropertyExpense?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_887':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_333':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: {
                expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value },
              },
            });
            break;
          case 'USA_337':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_328':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_330':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: { value: (taxInput.scheduleE?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_367':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_357':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_350':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_355':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_372':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: {
                supplementalPayments: { value: (taxInput.scheduleF?.supplementalPayments?.value || 0) + value },
              },
            });
            break;
          case 'USA_349':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_543':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_359':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_368':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { sales: { value: (taxInput.scheduleF?.sales?.value || 0) + value } },
            });
            break;
          case 'USA_377':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: { value: (taxInput.scheduleF?.othIncome?.value || 0) + value } },
            });
            break;
          case 'USA_371':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_361':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_360':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_353':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_345':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_347':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_351':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_362':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_352':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_378':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_356':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_365':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_346':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_366':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_364':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_369':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: { value: (taxInput.scheduleF?.othIncome?.value || 0) + value } },
            });
            break;
          case 'USA_370':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: { value: (taxInput.scheduleF?.othIncome?.value || 0) + value } },
            });
            break;
          case 'USA_363':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_358':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_348':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_375':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: { value: (taxInput.scheduleF?.othIncome?.value || 0) + value } },
            });
            break;
          case 'USA_344':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: { value: (taxInput.scheduleF?.expenses?.value || 0) + value } },
            });
            break;
          case 'USA_303':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { revenueSelf: { value: (taxInput.businessIncome?.revenueSelf?.value || 0) + value } },
            });
            break;
          case 'USA_302':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_820':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                deductibleBusinessMileageSelf: {
                  value: (taxInput.businessIncome?.deductibleBusinessMileageSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_495':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                costOfGoodsSelf: { value: (taxInput.businessIncome?.costOfGoodsSelf?.value || 0) + value },
              },
            });
            break;
          case 'USA_299':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_494':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                costOfGoodsSelf: { value: (taxInput.businessIncome?.costOfGoodsSelf?.value || 0) + value },
              },
            });
            break;
          case 'USA_496':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                costOfGoodsSelf: { value: (taxInput.businessIncome?.costOfGoodsSelf?.value || 0) + value },
              },
            });
            break;
          case 'USA_306':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_310':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_318':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_301':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_293':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                revenueSelf: { value: (taxInput.businessIncome?.revenueSelf?.value || 0) + value },
              },
            });
            break;
          case 'USA_685':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_315':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_304':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_312':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_313':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_316':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_297':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_311':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_308':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_307':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_317':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_309':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_314':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_300':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_294':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                mealsAndEntertainmentSelf: {
                  value: (taxInput.businessIncome?.mealsAndEntertainmentSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_298':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_305':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_493':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                costOfGoodsSelf: { value: (taxInput.businessIncome?.costOfGoodsSelf?.value || 0) + value },
              },
            });
            break;
          case 'USA_321':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { shortTermGains: { value: (taxInput.capitalGains?.shortTermGains?.value || 0) + value } },
            });
            break;
          case 'USA_810':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { shortTermGains: { value: (taxInput.capitalGains?.shortTermGains?.value || 0) + value } },
            });
            break;
          case 'USA_323':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { longTermGains: { value: (taxInput.capitalGains?.longTermGains?.value || 0) + value } },
            });
            break;
          case 'USA_283':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                allowableMortgageAndOtherDeductibleInterest: {
                  value:
                    (taxInput.scheduleADeductions?.allowableMortgageAndOtherDeductibleInterest?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_280':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                charitableContributions: {
                  value: (taxInput.scheduleADeductions?.charitableContributions?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_486':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_272':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_484':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: { value: (taxInput.scheduleADeductions?.medicalAndDental?.value || 0) + value },
              },
            });
            break;
          case 'USA_485':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                charitableContributions: {
                  value: (taxInput.scheduleADeductions?.charitableContributions?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_271':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_274':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: { value: (taxInput.scheduleADeductions?.medicalAndDental?.value || 0) + value },
              },
            });
            break;
          case 'USA_273':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: { value: (taxInput.scheduleADeductions?.medicalAndDental?.value || 0) + value },
              },
            });
            break;
          case 'USA_535':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_821':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_523':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductionsNoLimit: {
                  value: (taxInput.scheduleADeductions?.miscDeductionsNoLimit?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_284':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_822':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: { value: (taxInput.scheduleADeductions?.medicalAndDental?.value || 0) + value },
              },
            });
            break;
          case 'USA_545':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                allowableMortgageAndOtherDeductibleInterest: {
                  value:
                    (taxInput.scheduleADeductions?.allowableMortgageAndOtherDeductibleInterest?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_522':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                estimatedTaxesPaidToDatePlusProjected: {
                  value: (taxInput.stateAndLocalIncomeTax?.estimatedTaxesPaidToDatePlusProjected?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_282':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_277':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_276':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_281':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductions: { value: (taxInput.scheduleADeductions?.miscDeductions?.value || 0) + value },
              },
            });
            break;
          case 'USA_490':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: {
                taxableInterest: { value: (taxInput.divInterest?.taxableInterest?.value || 0) + value },
              },
            });
            break;
          case 'USA_287':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: {
                taxableInterest: { value: (taxInput.divInterest?.taxableInterest?.value || 0) + value },
              },
            });
            break;
          case 'USA_286':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: {
                dividends: { value: (taxInput.divInterest?.dividends?.value || 0) + value },
              },
            });
            break;
          case 'USA_683':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: {
                qualifiedDividends: { value: (taxInput.divInterest?.qualifiedDividends?.value || 0) + value },
              },
            });
            break;
          case 'USA_488':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: {
                shortTermGains: { value: (taxInput.capitalGains?.shortTermGains?.value || 0) + value },
              },
            });
            break;
          case 'USA_257':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                otherIncomeGainsOrLosses: {
                  value: (taxInput.otherIncome?.otherIncomeGainsOrLosses?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_556':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_557':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_259':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_562':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_555':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_561':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: {
                  value: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_261':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                alimonyReceived: { value: (taxInput.otherIncome?.alimonyReceived?.value || 0) + value },
              },
            });
            break;
          case 'USA_262':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: {
                allowableIRADeduction: { value: (taxInput.adjustments?.allowableIRADeduction?.value || 0) + value },
              },
            });
            break;
          case 'USA_481':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: {
                allowableIRADeduction: { value: (taxInput.adjustments?.allowableIRADeduction?.value || 0) + value },
              },
            });
            break;
          case 'USA_519':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                socialSecurityRRAIncome: {
                  value: (taxInput.otherIncome?.socialSecurityRRAIncome?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_520':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                socialSecurityRRAIncome: {
                  value: (taxInput.otherIncome?.socialSecurityRRAIncome?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_264':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: {
                alimonyPaid: { value: (taxInput.adjustments?.alimonyPaid?.value || 0) + value },
              },
            });
            break;
          case 'USA_382':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_385':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                unspecifiedBusinessExpensesSelf: {
                  value: (taxInput.businessIncome?.unspecifiedBusinessExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_381':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_384':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_386':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                mealsAndEntertainmentSelf: {
                  value: (taxInput.businessIncome?.mealsAndEntertainmentSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_824':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                deductibleBusinessMileageSelf: {
                  value: (taxInput.businessIncome?.deductibleBusinessMileageSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_390':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_389':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_391':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                businessUseOfHomeSelf: {
                  value: (taxInput.businessIncome?.businessUseOfHomeSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_383':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: {
                  value: (taxInput.businessIncome?.otherAllowableExpensesSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_461':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              withholdingsAndSummary: {
                withholdingsSelf: {
                  value: (taxInput.withholdingsAndSummary?.withholdingsSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_507':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              withholdingsAndSummary: {
                withholdingsSpouse: {
                  value: (taxInput.withholdingsAndSummary?.withholdingsSpouse?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_506':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              wages: {
                spouseWages: {
                  value: (taxInput.wages?.spouseWages?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_460':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              wages: {
                selfWages: {
                  value: (taxInput.wages?.selfWages?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_464':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSelf: {
                  value: (taxInput.stateAndLocalIncomeTax?.withholdingsSelf?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_511':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSpouse: {
                  value: (taxInput.stateAndLocalIncomeTax?.withholdingsSpouse?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_509':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSpouse: {
                  value: (taxInput.stateAndLocalIncomeTax?.withholdingsSpouse?.value || 0) + value,
                },
              },
            });
            break;
          case 'USA_462':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSelf: {
                  value: (taxInput.stateAndLocalIncomeTax?.withholdingsSelf?.value || 0) + value,
                },
              },
            });
            break;
        }
      }
    }
    return taxInput;
  }, {});

  return taxInputProps;
};

export const getRegularTaxBrackets = (
  year: number,
  filingStatus: FilingStatus,
  taxRates?: TaxRates,
): TaxBracketRow[] => {
  const yearly = taxRates?.yearlyData[year];
  if (!yearly) {
    throw new Error(`No tax data available for year: ${year}`);
  }

  const rates = yearly.regularTaxRates;
  const limits = yearly.regularTaxRatesIncomeLimits[filingStatus];

  if (!limits) {
    throw new Error(`Invalid filing status: ${filingStatus}`);
  }

  // Words for first, second, third...
  const ordinal = ['Lowest', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];

  return rates.map((rate, index) => ({
    bracketName: ordinal[index],
    rate: rate,
    incomeThreshold: limits[index],
  }));
};

export const getAMTBrackets = (year: number, filingStatus: FilingStatus, taxRates?: TaxRates): TaxBracketRow[] => {
  const yearly = taxRates?.yearlyData[year];
  if (!yearly) {
    throw new Error(`No tax data available for year: ${year}`);
  }

  const { amtRatesRateLow, amtRatesRateHigh, amtRatesIncomeHigh } = yearly;

  if (!amtRatesIncomeHigh[filingStatus]) {
    throw new Error(`Invalid filing status: ${filingStatus}`);
  }

  return [
    {
      bracketName: 'Lowest',
      rate: amtRatesRateLow,
      incomeThreshold: 0,
    },
    {
      bracketName: 'Second',
      rate: amtRatesRateHigh,
      incomeThreshold: amtRatesIncomeHigh[filingStatus],
    },
  ];
};
